import { Messages } from '../../../../codegen/Localize';
import { IContentInfo } from '../../../../ts/models/IContentInfo';
import { IDeleteAction as IDeleteActionApi } from '../../../../ts/ServerApi/types/actionNames';
import { deleteContentsAction } from '../../../actions/spaces/DeleteContentAction';
import { IEntityAction } from './IEntityAction';
import { isSingleEmbeddedDatasource } from './IEntityActionHelpers';

export const DeleteAction: IEntityAction<IContentInfo, IDeleteActionApi> = {
  name: 'delete',
  translateName: Messages.delete_action,
  isVisible: (targetItems: IContentInfo[]) => {
    return !isSingleEmbeddedDatasource(targetItems);
  },
  isClickable: (availableActions: IDeleteActionApi) => !!(availableActions && availableActions.del),
  createReduxAction: (targetItems: IContentInfo[]) => deleteContentsAction(targetItems)
};
